<template>
  <TwoColumnQuizReviewLayout>
    <template #responses>
      <ResponseItem
        v-for="(item, id) in response"
        :key="id"
        :option="item"
        :showCheckMarkIcon="true"
        :class="{
          'correct': item.correct,
          'incorrect': !item.correct,
        }"
      />
    </template>
    <template #answers>
      <ResponseItem
        v-for="(item, id) in correctAnswers"
        :key="id"
        :option="item"
        :showCheckMarkIcon="false"
      />
    </template>
    <template #otherCorrect v-if="otherCorrectAnswers && otherCorrectAnswers.length > 0">
      <ResponseItem
        v-for="(item, id) in otherCorrectAnswers"
        :key="id"
        :option="item"
        :showCheckMarkIcon="false"
      />
    </template>
  </TwoColumnQuizReviewLayout>
</template>

<script>
import TwoColumnQuizReviewLayout from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/TwoColumnQuizReviewLayout.vue'
import ResponseItem from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/ResponseItem.vue'

export default {
  components: {
    ResponseItem,
    TwoColumnQuizReviewLayout,
  },
  props: {
    answer: {
      type: Object,
      default: () => {
      },
    },
  },
  computed: {
    correctAnswers() {
      const answers = this.answer?.answers
      return Array.isArray(answers) ? answers : []
    },
    response() {
      return this.answer?.response?.map((answer) => ({
        title: answer.title,
        correct: answer.is_correct === 'true',
      }))
    },
    otherCorrectAnswers() {
      const otherCorrectAnswers = this.answer?.other_accepted_answers
      return Array.isArray(otherCorrectAnswers) ? otherCorrectAnswers : []
    },
  },
}
</script>
